import { render, staticRenderFns } from "./sectionDashboardProgressUpdateStyle2.vue?vue&type=template&id=155b17f6"
import script from "./sectionDashboardProgressUpdateStyle2.vue?vue&type=script&lang=js"
export * from "./sectionDashboardProgressUpdateStyle2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports